// src/tokens/letterSpacing.ts
var letterSpacingNone = 0;
var letterSpacingSmall = 0.2;
var letterSpacingMedium = 0.3;
var letterSpacingLarge = 0.4;
export { letterSpacingNone, letterSpacingSmall, letterSpacingMedium, letterSpacingLarge };